import { Box, keyframes } from "@mui/material";

import { colors } from "@/Utils";

const textAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const PageLoader = ({ themeMode }) => {
  return (
    <Box
      className="spinner"
      sx={{
        top: 0,
        left: 0,
        backgroundColor: themeMode === "light" ? colors.secondaryColor : colors.gray,
        width: "100%",
        height: "100%",
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .spinner-text": {
          border: `5px solid ${colors.datePickerBg}`,
          borderRadius: "50%",
          borderTop: `7px solid ${colors.yellow}`,
          width: "70px",
          height: "70px",
          animation: `${textAnimation} 2s infinite`,
        },
      }}
    >
      <Box className="spinner-text" />
    </Box>
  );
};
